import {Component, forwardRef, Inject, ViewChild} from '@angular/core';
import {LoadingController, NavController, NavParams} from 'ionic-angular';
import {EbsWebService} from "../../services/ebsWebService";
import {EbsComponentService} from "../../services/ebsComponentService";
import {SignaturePad} from "angular2-signaturepad/signature-pad";
declare var $;

@Component({
  selector: 'signature',
  templateUrl: 'signature.html',
  providers: [EbsWebService]
})
export class Signature {

  title: any;
  signatureElement: any;


  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  private signaturePadOptions: Object = {
    'minWidth': 5,
    'canvasWidth': 500,
    'canvasHeight': 300
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private _ebsWebService: EbsWebService, @Inject(forwardRef(() => EbsComponentService)) private _ebsComponentService: EbsComponentService,
    public loadingCtrl: LoadingController) {
    this.signatureElement = navParams.get('signatureElement');
    this.title = this.signatureElement.Caption;

  }

  ionViewWillLeave(){
    let base64 = encodeURIComponent(this.signaturePad.toDataURL().split(',')[1]);
    let params = this.signatureElement.ListItemAction[0].PostParameters.replace("FILEBYTES", base64);
    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);
    this._ebsWebService.postData(this.signatureElement.ListItemAction[0].ActionUrl,postPayloadObject).toPromise().catch(error => {
      console.error(error);
    });
  }

  ngAfterViewInit() {
    let canvasWidth = $("signature .scroll-content").width()-20;
    this.signaturePad.set('minWidth', 5);
    this.signaturePad.set('canvasWidth', canvasWidth);
    this.signaturePad.set('canvasHeight', 500);
    this.signaturePad.set('backgroundColor', 'rgb(255,255,255)');
    this.signaturePad.clear();
  }

  drawComplete() {

  }

  drawStart() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/signature/signature.ts